module.exports = __webpack_public_path__ + "img/flour.0242c481.png";